import { render } from "./RichText.vue?vue&type=template&id=5a206d34&scoped=true"
import script from "./RichText.vue?vue&type=script&lang=js"
export * from "./RichText.vue?vue&type=script&lang=js"

import "./RichText.vue?vue&type=style&index=0&id=5a206d34&lang=scss"
import "./RichText.vue?vue&type=style&index=1&id=5a206d34&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a206d34"]])

export default __exports__